<template>
  <b-modal
    id="link-existing-table-modal"
    ref="bModal"
    :title="$t('Vincular Tabela Existente')"
    size="md"
    cancel-variant="outline-secondary"
    :ok-title="$t('Vincular')"
    :cancel-title="$t('Cancelar')"
    @ok="handleOk"
    @hidden="resetModal"
    :ok-disabled="!selectedTableId || isLinking"
    no-close-on-backdrop
    ignore-enforce-focus-selector=".vs__dropdown-menu, .vs__dropdown-menu *"
  >
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col cols="12">
          <p>{{ $t('Selecione a tabela que deseja vincular ao modelo') }} <strong>{{ modelName }}</strong>:</p>
          <b-form-group>
            <v-select
              v-model="selectedTableId"
              :options="tables"
              :reduce="table => table.id"
              label="name"
              :placeholder="$t('Buscar Tabela DTC...')"
              @search="debounceSearch"
              :loading="isLoadingTables"
            >
              <template #no-options>
                {{ $t('Nenhuma tabela encontrada.') }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BRow, BCol, BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal, BForm, BRow, BCol, BFormGroup, vSelect
  },
  props: {
    assetModelId: {
      type: String,
      default: null
    },
    modelName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selectedTableId: null,
      tables: [],
      isLoadingTables: false,
      isLinking: false,
      searchTimeout: null,
    }
  },
  methods: {
    show() {
      this.$refs.bModal.show()
      this.fetchTables('')
    },
    debounceSearch(query, loading) {
      if (loading) loading(true)
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.fetchTables(query).finally(() => {
          if (loading) loading(false)
        })
      }, 300)
    },
    fetchTables(query) {
      this.isLoadingTables = true
      return store.dispatch('app-dtc/fetchTables', {
        q: query,
        page: 1,
        perPage: 50
      }).then(response => {
        this.tables = response.data?.data || []
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: this.$t('Erro ao carregar tabelas'), icon: 'AlertTriangleIcon', variant: 'danger' }
        })
      }).finally(() => {
        this.isLoadingTables = false
      })
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.handleSubmit()
    },
    handleSubmit() {
      if (!this.selectedTableId || !this.assetModelId) return

      this.isLinking = true
      
      store.dispatch('app-dtc/linkModel', { 
        dtcTableId: this.selectedTableId, 
        assetModelId: this.assetModelId 
      })
      .then(() => {
        this.$toast({
          component: ToastificationContent,
          props: { title: this.$t('Modelo vinculado com sucesso'), icon: 'CheckIcon', variant: 'success' }
        })
        this.$emit('linked')
        this.$refs.bModal.hide()
      })
      .catch((error) => {
        this.$toast({
          component: ToastificationContent,
          props: { title: this.$t('Erro ao tentar vincular a tabela'), icon: 'AlertTriangleIcon', variant: 'danger' }
        })
      })
      .finally(() => {
        this.isLinking = false
      })
    },
    resetModal() {
      this.selectedTableId = null
      this.tables = []
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
